import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import { Table } from '../../../../components/Table'
import Button from '../../../../components/components-ui/Button/Button'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../../services/Api'
import Loading from '../../../../components/components-ui/Loading/Loading'
import { toast } from 'react-toastify'

const API_PERFIS = "/perfil/index";

export default function Perfil() {
  const [perfis, setPerfis] = useState([])
  const [showLoading, setShowLoading] = useState(false)

  async function getPerfil() {
    await api.get(API_PERFIS)
      .then((res) => {
        if (res.data.error === 0) {
          setPerfis(res.data.data);
          return;
        }
        toast.error(res.data.msg);
      })
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    getPerfil()
  }, [])

  // Colunas da tabela
  const columns = [
    {
      column: 'Perfis',
    },
  ]

  return (
    <Container>
      <h3>Listagem de Perfis</h3>
      <Link to="/usina/perfil/novo/" style={{ display: "contents" }}>
        <Button title="Novo" type="button" />
      </Link>

      <div className={styles.content}>
        <Table edit columns={columns}>
          {perfis.map(
            (values) => (
              <tr key={values.IdPerfil}>
                <td>
                  <Link
                    to={`/usina/perfil/edit/${values.IdPerfil}`}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </Link>
                </td>
                <td>{values.Perfil}</td>
              </tr>
            )
          )}
        </Table>
        <div className={styles.loading}>
          <Loading display={showLoading ? 'block' : 'none'} />
        </div>
      </div>
    </Container>
  )
}
